import { SaleChannel } from '@/constants'
import { useAuth } from '@/containers'
import type { Property, PropertyValue } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect, useState, type ReactNode } from 'react'
import Iframe from 'react-iframe'
import DrawBottom from '../DrawBottom'
import ImageOptimize from '../ImageOptimize'
import OutstandingFeature from './OutstandingFeature'
interface SpecificationsType {
  specifications: Property[]
  openSpecModal: boolean
  setOpenSpecModal: Dispatch<SetStateAction<boolean>>
  outstandingFeatures: {
    order: number
    value: {
      vi: string
      en: string
    }
  }[]
}

export const Specifications = ({
  specifications,
  openSpecModal = false,
  outstandingFeatures,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setOpenSpecModal,
}: SpecificationsType) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isOpenDraw, setIsOpenDraw] = useState(openSpecModal)
  const [isOpenBrand, setIsOpenBrand] = useState(false)
  const [isPolicyDraw, setIsPolicyDraw] = useState(false)
  const [dataPolicy, setDataPolicy] = useState<Property>()
  const [dataBrand, setDataBrand] = useState<PropertyValue>()
  const { token, user } = useAuth()
  const [openSpecifications, setOpenSpecifications] = useState(false)

  const specificationsData = specifications?.filter(
    item => !item?.policy && item?.channels?.includes(SaleChannel.B2C)
  )
  const specificationsDataB2E = specifications?.filter(
    item => !item?.policy && item?.channels?.includes(SaleChannel.B2E)
  )
  const policyData = specifications?.filter(
    item => item?.policy && item?.channels?.includes(SaleChannel.B2C)
  )
  const policyDataB2E = specifications?.filter(
    item => item?.policy && item?.channels?.includes(SaleChannel.B2E)
  )
  useEffect(() => setIsOpenDraw(openSpecModal), [openSpecModal])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const renderSpecificationsHighlight = (item: Property): ReactNode => {
    switch (item.type as string) {
      case 'multipleSelect':
        return item.values.map((e: PropertyValue, i: number) => {
          return (
            <span
              key={i}
              className="mr-1 after:content-[','] inline-block last:mr-0 last:after:content-[unset]"
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'singleSelect':
        return item.values.map((e: PropertyValue, i: number) => {
          return e.link ? (
            <span
              onClick={() => {
                setIsOpenBrand(true)
                setDataBrand(e)
              }}
              className="text-blue cursor-pointer mr-1 after:content-[','] inline-block last:mr-0 last:after:content-[unset]"
              key={i}
            >
              {getTranslate(e.value)}
            </span>
          ) : (
            <span
              className="mr-1 after:content-[','] inline-block last:mr-0 last:after:content-[unset]"
              key={i}
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'input':
        return <span>{getTranslate(item.value)}</span>
      default:
        break
    }
  }
  const renderSpecificationsItem = (item: Property): ReactNode => {
    switch (item.type as string) {
      case 'multipleSelect':
        return item.values.map((e: PropertyValue, i: number) => {
          return (
            <span
              key={i}
              className="mr-1 after:content-[','] block last:mr-0 last:after:content-[unset]"
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'singleSelect':
        return item.values.map((e: PropertyValue, i: number) => {
          return (
            <span
              className="mr-1 after:content-[','] inline-block last:mr-0 last:after:content-[unset]"
              key={i}
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'input':
        return <span>{getTranslate(item.value)}</span>
      default:
        break
    }
  }

  const handleClickPolicy = (e: Property) => {
    setDataPolicy(e)
    setIsPolicyDraw(true)
  }
  // const onDevelopment = () => bus.emit(EventBus.DEVELOPMENT_MODAL, true)
  return (
    <>
      <section className='border-t-8 py-4 border-[#F3F4F6]'>
        <h2 className='text-base px-2 pb-2 font-bold'>Pico cam kết</h2>

        {user?.saleChannel == SaleChannel.B2E ? (
          <div className='listPolicy w-full'>
            {policyDataB2E &&
              policyDataB2E.map((item, i) => {
                return (
                  <div
                    className='itemPolicy px-2 h-8 flex items-center w-full relative'
                    key={i}
                    onClick={() => handleClickPolicy(item)}
                  >
                    <div className='icon max-h-7 flex-[28px] max-w-[28px] text-center justify-center flex'>
                      {item.image ? (
                        <ImageOptimize
                          src={item.image}
                          width={28}
                          height={28}
                          alt={getTranslate(item.name)}
                          className='object-contain max-h-7 max-w-[28px]'
                        />
                      ) : (
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='22'
                          height='19'
                          viewBox='0 0 22 19'
                          fill='none'
                        >
                          <path
                            d='M7.2 16.3496V16.1496H7H2C1.01046 16.1496 0.2 15.3392 0.2 14.3496V2.34961C0.2 1.36007 1.01046 0.549609 2 0.549609H20C20.9895 0.549609 21.7999 1.35998 21.8 2.34944C21.8 2.3495 21.8 2.34955 21.8 2.34961L21.79 14.3494V14.3496C21.79 15.3405 20.9882 16.1496 20 16.1496H15H14.8V16.3496V17.3496C14.8 17.7892 14.4395 18.1496 14 18.1496H8C7.56046 18.1496 7.2 17.7892 7.2 17.3496V16.3496ZM3 14.5496H19C19.6605 14.5496 20.2 14.0101 20.2 13.3496V3.34961C20.2 2.68915 19.6605 2.14961 19 2.14961H3C2.33954 2.14961 1.8 2.68915 1.8 3.34961V13.3496C1.8 14.0101 2.33954 14.5496 3 14.5496Z'
                            fill='#010103'
                            stroke='white'
                            strokeWidth='0.4'
                          />
                        </svg>
                      )}
                    </div>
                    <div className='content flex items-center ml-2 text-sm gap-1'>
                      <div className='label'>{getTranslate(item.name)}</div>
                      <div className='value'>{getTranslate(item.value)}</div>
                      <div className='unit lowercase'>
                        {getTranslate(item?.unit?.name)}
                      </div>
                    </div>
                  </div>
                )
              })}
          </div>
        ) : (
          <div className='listPolicy w-full'>
            {policyData &&
              policyData.map((item, i) => {
                return item && item.value && item.value.vi !== '' ? (
                  <div
                    className='itemPolicy px-2 h-8 flex items-center w-full relative'
                    key={i}
                    onClick={() => handleClickPolicy(item)}
                  >
                    <div className='icon max-h-7 flex-[28px] max-w-[28px] text-center justify-center flex'>
                      {item.image ? (
                        <ImageOptimize
                          src={item.image}
                          width={28}
                          height={28}
                          alt={getTranslate(item.name)}
                          className='object-contain max-h-7 max-w-[28px]'
                        />
                      ) : (
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='22'
                          height='19'
                          viewBox='0 0 22 19'
                          fill='none'
                        >
                          <path
                            d='M7.2 16.3496V16.1496H7H2C1.01046 16.1496 0.2 15.3392 0.2 14.3496V2.34961C0.2 1.36007 1.01046 0.549609 2 0.549609H20C20.9895 0.549609 21.7999 1.35998 21.8 2.34944C21.8 2.3495 21.8 2.34955 21.8 2.34961L21.79 14.3494V14.3496C21.79 15.3405 20.9882 16.1496 20 16.1496H15H14.8V16.3496V17.3496C14.8 17.7892 14.4395 18.1496 14 18.1496H8C7.56046 18.1496 7.2 17.7892 7.2 17.3496V16.3496ZM3 14.5496H19C19.6605 14.5496 20.2 14.0101 20.2 13.3496V3.34961C20.2 2.68915 19.6605 2.14961 19 2.14961H3C2.33954 2.14961 1.8 2.68915 1.8 3.34961V13.3496C1.8 14.0101 2.33954 14.5496 3 14.5496Z'
                            fill='#010103'
                            stroke='white'
                            strokeWidth='0.4'
                          />
                        </svg>
                      )}
                    </div>
                    <div className='content inline-block items-center ml-2 text-sm gap-1'>
                      <span className='label mr-1'>
                        {getTranslate(item.name)}
                      </span>
                      <span className='value'>{getTranslate(item.value)}</span>
                      <span className='unit ml-1 lowercase'>
                        {getTranslate(item?.unit?.name)}
                      </span>
                    </div>
                  </div>
                ) : (
                  ''
                )
              })}
          </div>
        )}

        <DrawBottom
          open={isPolicyDraw}
          onClose={() => setIsPolicyDraw(false)}
          title={''}
          scroll={false}
        >
          <div className='policyDraw'>
            <div
              dangerouslySetInnerHTML={{
                __html: getTranslate(dataPolicy?.content),
              }}
            ></div>
          </div>
        </DrawBottom>

        <DrawBottom
          open={isOpenBrand}
          onClose={() => setIsOpenBrand(false)}
          title={'Thương hiệu'}
          titleClassName='!h-[50px]'
          bodyClassName='!min-h-[calc(60vh-70px)]'
        >
          <Iframe
            url={`${dataBrand?.link}?hideMenu=true` || ''}
            position='absolute'
            width='100%'
            id='myId'
            referrerpolicy='same-origin'
            className='pr-[25px]'
            height='100%'
          />
        </DrawBottom>
      </section>
      <OutstandingFeature outstandingFeatures={outstandingFeatures} />
      <section className='border-t-8 pt-4 border-[#F3F4F6] relative pb-[30px]'>
        <h2 className='text-base px-2 pb-2 font-bold'>Thông số kỹ thuật</h2>
        <div
          className={` overflow-hidden ${
            openSpecifications ? 'h-auto' : 'max-h-[300px]'
          }`}
        >
          {token && user?.saleChannel === SaleChannel.B2E
            ? specificationsDataB2E &&
              specificationsDataB2E.map((item, index) => {
                if (getTranslate(item.value) != '' || item.values.length > 0) {
                  return (
                    <div
                      key={index}
                      className='flex w-full flex-wrap justify-center bg-[#F3F4F6] nth-2n:bg-white py-2 px-4'
                    >
                      <span className='label text-sm flex-40 max-w-[40%] leading-[20px] block font-semibold text-ellipsis overflow-hidden line-clamp-1'>
                        {getTranslate(item.name)}
                      </span>
                      <span className='value text-sm flex-60 max-w-[60%] flex leading-[20px] w-full'>
                        {renderSpecificationsItem(item)}
                      </span>
                    </div>
                  )
                }
              })
            : specificationsData &&
              specificationsData
                .filter(item => !item.policy)
                .map((item, index) => {
                  if (
                    getTranslate(item.value) != '' ||
                    item.values.length > 0
                  ) {
                    return (
                      <div
                        key={index}
                        className='flex w-full flex-wrap justify-center bg-[#F3F4F6] nth-2n:bg-white py-2 px-4'
                      >
                        <span className='label text-sm flex-40 max-w-[40%] leading-[20px] block font-semibold text-ellipsis overflow-hidden line-clamp-1'>
                          {getTranslate(item.name)}
                        </span>
                        <span
                          className={`${
                            item.type === 'multipleSelect'
                              ? 'inline-grid'
                              : 'flex'
                          } value text-sm flex-60 max-w-[60%] leading-[20px] w-full`}
                        >
                          {renderSpecificationsItem(item)}
                        </span>
                      </div>
                    )
                  }
                })}
        </div>
        {specificationsData &&
          specificationsData.filter(item => !item.policy).length > 8 && (
            <div
              className={`w-full text-[#FF0000] font-semibold text-center bg-gradient-to-b  from-[#fff]/20 from-5% to-[#fff] to-40%  bottom-[-10px] ${
                openSpecifications ? 'static py-2 ' : 'absolute py-8'
              }`}
              onClick={() => setOpenSpecifications(!openSpecifications)}
            >
              <span>{openSpecifications ? 'Thu gọn' : 'Xem thêm'}</span>
            </div>
          )}
      </section>
    </>
  )
}

export default Specifications
